// extracted by mini-css-extract-plugin
export default {"root":"RenderTitle_root__CTdIc"};